/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import { loginAssemp } from '../core/_requests'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useAuth } from '../core/Auth'
import { User } from '../core/_models'
import Cookies from 'js-cookie'


const loginSchema = Yup.object().shape({
    email: Yup.string()
        .email('Wrong email format')
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Campo obrigatório'),
    password: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Campo obrigatório'),
})

const initialValues = {
    email: '',
    password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
    const [loading, setLoading] = useState(false)
    const { saveAuth, setCurrentUser } = useAuth()
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    // Function to check cookies and transfer selectedModule to sessionStorage
    const checkAndTransferSelectedModule = (user: any) => {
        if (user?.idUsuario) {
            const cookieKey = `selectedModule_user${user.idUsuario}`;
            const savedModule = Cookies.get(cookieKey);
            
            if (savedModule) {
                // Transfer from cookie to sessionStorage
                sessionStorage.setItem('selectedModule', savedModule);
            }
        }
    };

    const formik = useFormik({
        initialValues,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            setLoading(true)
            try {

            const response: any = await loginAssemp({ login: values.email, senha: values.password })
            const user: any = response.data
            
            // Verifica se precisa trocar senha antes de salvar no localStorage
            if (response.data.trocarSenhaExpirada || response.data.trocarSenhaTemporaria) {
                // Salva temporariamente os dados do usuário para a página de recuperação
                sessionStorage.setItem('tempUser', JSON.stringify(user))
                navigate('/auth/recover-password');
                return
            }
            
            // Só salva no localStorage se não precisar trocar senha
            localStorage.setItem('user', JSON.stringify(user))
            setCurrentUser(user)
            saveAuth(user.token)
            
            // Check and transfer selectedModule from cookies to sessionStorage
            checkAndTransferSelectedModule(user)
                // const {data: user} = await getUserByToken(auth.api_token)
                // const {data: auth} = await login(values.email, values.password)
                // saveAuth(auth)
                // const {data: user} = await getUserByToken(auth.api_token)
                // setCurrentUser(user)
            } catch (error: any) {
                saveAuth(undefined)
                const message = error?.response?.data?.message ?? error?.response?.data ?? 'Usuário inexistente ou senha inválida'
                setStatus(typeof message === 'string' ? message : 'Usuário inexistente ou senha inválida')
                setSubmitting(false)
                setLoading(false)
            }
        },
    })

    return (
        <div>
            <form
                className='form w-100 auth-form'
                onSubmit={formik.handleSubmit}
                noValidate
                id='kt_login_signin_form'
            >

                <div className='text-center'>
                    <img src={toAbsoluteUrl('/media/assemp/assemp-logo-2.svg')} style={{ mixBlendMode: 'multiply' }} className='logo' />
                </div>
                <div className='text-center headline'>
                    <h1 className='mb-0'>
                        Bem-vindo(a)!
                    </h1>
                    <p>
                        Informe seus dados , para realizar o login
                    </p>
                </div>

                {/* begin::Form group */}
                {formik.status && (
                    <div className="alert alert-danger text-center mt-3" role="alert">
                        {formik.status}
                    </div>
                )}
                <div className='fv-row mb-8'>
                    <label className='form-label fs-6  text-dark'>Usuário</label>
                    <input
                        placeholder='Usuário'
                        {...formik.getFieldProps('email')}
                        className={clsx(
                            'form-control bg-transparent',
                            { 'is-invalid': formik.touched.email && formik.errors.email },
                            {
                                'is-valid': formik.touched.email && !formik.errors.email,
                            }
                        )}
                        type='email'
                        name='email'
                        autoComplete='off'
                    />
                    {formik.touched.email && formik.errors.email && (
                        <div className='fv-plugins-message-container'>
                            <span role='alert'>{formik.errors.email}</span>
                        </div>
                    )}
                </div>
                {/* end::Form group */}

                {/* begin::Form group */}
                <div className='fv-row mb-3'>
                    <label className='form-label  text-dark fs-6 mb-0'>Senha</label>
                    <div className="input-group mb-3">

                        <input
                            type={showPassword ? 'text' : 'password'}
                            className="form-control custom-input"
                            placeholder="Digite sua senha"
                            {...formik.getFieldProps('password')}
                            aria-label="Password"
                            aria-describedby="toggle-password"
                        />
                        <span
                            className="input-group-text"
                            id="toggle-password"
                            style={{ cursor: 'pointer', background: '#fff', borderLeft: '0' }}
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            <img
                                src={showPassword ? "/media/icons/show.svg" : "/media/icons/hide.svg"}
                                alt={showPassword ? "Mostrar senha" : "Esconder senha"}
                                width="20"
                                height="20"
                            />
                        </span>
                    </div>

                    {formik.touched.password && formik.errors.password && (
                        <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                                <span role='alert'>{formik.errors.password}</span>
                            </div>
                        </div>
                    )}
                </div>
                {/* end::Form group */}



                {/* begin::Action */}
                <div className='d-grid mb-5'>
                    <button
                        type='submit'
                        id='kt_sign_in_submit'
                        className='btn btn-primary'
                        style={{
                            backgroundColor: '#009FE3'
                        }}
                        disabled={formik.isSubmitting || !formik.isValid}
                    >
                        {!loading && <span className='indicator-label'>Acessar</span>}
                        {loading && (
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                Carregando...
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                        )}
                    </button>
                </div>
                {/* begin::Wrapper */}
                <div className='d-flex text-center justify-content-center'>
                    <div />

                    {/* begin::Link */}
                    <Link to='/auth/forgot-password' className='link-primary'>
                        Esqueceu a senha?
                    </Link>
                    {/* end::Link */}
                </div>
                {/* end::Wrapper */}
                {/* end::Action */}

                {/* <div className='text-gray-500 text-center fw-semibold fs-6'>
        Not a Member yet?{' '}
        <Link to='/auth/registration' className='link-primary'>
        Sign up
        </Link>
        </div> */}
            </form>
        </div>
    )
}
